import type { ReactNode } from 'react';
import { InfoTip } from './InfoTip';

// The canonical form-field wrapper (s48 platform standard, promoted from the per-page copies that
// grew across Clients/Services/Vendors/Packages/RecurringExpenses/Invite/Notifications):
// - REQUIRED fields show the red asterisk — the universal rule for every form, new or old (the
//   retro-sweep of the existing per-page Field copies is its own deferred item; new forms use THIS).
// - `tip` renders the shared InfoTip beside the label (the s30 item-9 standard for field help).
// - `error` renders inline below the control in the standard red.
// No em dashes in label/tip copy (locked rule).
export function Field({
  label,
  required,
  tip,
  error,
  children,
}: {
  label: string;
  required?: boolean;
  tip?: string;
  error?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <label className="block">
      <span className="mb-1.5 flex items-center gap-1 text-sm font-medium">
        {label}
        {required ? <span className="text-[var(--tint-red-text)]">*</span> : null}
        {tip ? <InfoTip text={tip} /> : null}
      </span>
      {children}
      {error ? <span className="mt-1 block text-xs text-[var(--tint-red-text)]">{error}</span> : null}
    </label>
  );
}
